export interface TicketModule {
    id: string;
    name: string;
    description: string;
}
export function createTicketModule(): TicketModule {
    return {
        id: '',
        name: '',
        description: '',
    };
}
